exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NewPatientForm__form{margin-top:12px;width:100%;max-width:300px}@media (max-width:500px){.NewPatientForm__form{margin-top:16px;max-width:none}}.NewPatientForm__field{margin-bottom:16px}.NewPatientForm__withRightMargin{margin-right:10px}.NewPatientForm__addPatient{margin-top:24px;margin-bottom:12px}", ""]);

// exports
exports.locals = {
	"form": "NewPatientForm__form",
	"field": "NewPatientForm__field",
	"withRightMargin": "NewPatientForm__withRightMargin",
	"addPatient": "NewPatientForm__addPatient"
};